<div class="limiter">
  <div class="container-login100">
    <div class="loading-shade" *ngIf="isLoading">
      <mat-spinner></mat-spinner>
    </div>
    <form [formGroup]="changePasswordForm" class="validate-user-form">
      <div class="text-center">
        <img
          class="login-logo"
          height="120px"
          src="assets/images/ez-logo.png"
          alt="Logo"
        />
      </div>
      <h4 class="text-center">Generate new password</h4>
      <div class="row">
        <div class="col-md-12 col-sm-12 col-12">
          <div class="form-group">
            <label>{{ "EMAIL" | translate }}</label>
            <input
              [attr.disabled]="true"
              formControlName="email"
              class="form-control"
              type="email"
            />
          </div>
        </div>
        <div class="col-md-12 col-sm-12 col-12">
          <div class="form-group">
            <label class="text-danger"
              >{{ "CURRENT_PASSWORD" | translate }} *</label
            >
            <input
              autocomplete="new-password"
              formControlName="oldPasswordPassword"
              class="form-control"
              type="password"
            />
            <div
              *ngIf="
                changePasswordForm.get('oldPasswordPassword').touched &&
                changePasswordForm.get('oldPasswordPassword').errors
              "
            >
              <div
                *ngIf="
                  changePasswordForm.get('oldPasswordPassword').errors?.required
                "
              >
                {{ "CURRENT_PASSWORD_IS_REQUIRED" | translate }}
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12 col-sm-12 col-12">
          <div class="form-group">
            <label class="text-danger"
              >{{ "NEW_PASSWORD" | translate }} *</label
            >
            <input
              autocomplete="new-password"
              formControlName="password"
              class="form-control"
              type="password"
            />
            <div
              *ngIf="
                changePasswordForm.get('password').touched &&
                changePasswordForm.get('password').errors
              "
            >
              <div *ngIf="changePasswordForm.get('password').errors?.required">
                {{ "PASSWORD_IS_REQUIRED" | translate }}
              </div>
              <div *ngIf="changePasswordForm.get('password').errors?.minlength">
                {{ "YOU_HAVE_TO_ENTER_AT_LEAST_6_DIGIT" | translate }}
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12 col-sm-12 col-12">
          <div class="form-group">
            <label class="text-danger"
              >{{ "CONFIRM_PASSWORD" | translate }} *</label
            >
            <input
              autocomplete="new-password"
              formControlName="confirmPassword"
              class="form-control"
              type="password"
            />
            <div
              *ngIf="
                changePasswordForm.get('confirmPassword').touched &&
                changePasswordForm.get('confirmPassword').errors
              "
            >
              <div
                *ngIf="
                  changePasswordForm.get('confirmPassword').errors?.required
                "
              >
                {{ "CONFIRM_PASSWORD_IS_REQUIRED" | translate }}
              </div>
            </div>
            <div
              *ngIf="
                changePasswordForm.get('confirmPassword').touched &&
                changePasswordForm.hasError('notSame')
              "
            >
              {{ "PASSWORDS_DO_NOT_MATCH" | translate }}
            </div>
            <div
              *ngIf="
                changePasswordForm.get('confirmPassword').errors?.minlength
              "
            >
              {{ "YOU_HAVE_TO_ENTER_AT_LEAST_6_DIGIT" | translate }}
            </div>
          </div>
        </div>
        <div class="col-md-12 col-sm-12 col-12">
          <button
            class="btn btn-success btn-sm m-right-10"
            (click)="changePassword()"
            cdkFocusInitial
          >
            <i class="fas fa-save"></i> Submit
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
